import * as React from 'react';

import { useAppSelector } from '@/App/hooks';
import { DeleteStep } from '@/App/types';
import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { ViolationDialog } from '@/components/common/ViolationDialog';
import { ConfirmDeleteAccountDialog } from '@/components/dialogs/ConfirmDeleteAccountDialog';
import { DeleteAccountDialog } from '@/components/dialogs/DeleteAccountDialog';
import { selectShowError } from '@/features/ui/selectShowError';
import { selectDeleteProfile } from '@/features/user/deleteProfile/selectDeleteProfile';
import { selectUserDeleteStep } from '@/features/user/selectUserDeleteStep';

interface DeleteAccountDialogWrapperProps {
  open: boolean;

  handleCancel(): void;
}

export const DELETE_ACCOUNT_DIALOG_WRAPPER_ID = 'delete-account-dialog-wrapper';

export const DeleteAccountDialogWrapper: React.FC<DeleteAccountDialogWrapperProps> = ({ open, handleCancel }) => {
  const deleteStep = useAppSelector(selectUserDeleteStep);
  const showError = useAppSelector(selectShowError);
  const deleteProfile = useAppSelector(selectDeleteProfile);
  const getDeleteAccountState = () => deleteProfile;

  if (!open || showError) {
    return null;
  }

  switch (deleteStep) {
    case DeleteStep.CONFIRM_DELETE: {
      return (
        <ConfirmDeleteAccountDialog
          dialogId={DELETE_ACCOUNT_DIALOG_WRAPPER_ID}
          open={true}
          handleCancel={handleCancel}
        />
      );
    }
    case DeleteStep.DELETE_REQUESTED: {
      return (
        <ViolationDialog
          dialogId={DELETE_ACCOUNT_DIALOG_WRAPPER_ID}
          titleId="SH.PG.ACCOUNTDELETIONREQUESTRECEIVED"
          elementId="SH.DLTPRFL.ALERT"
          open={true}
          onClose={handleCancel}
        />
      );
    }
    case DeleteStep.DELETE: {
      return (
        <DeleteAccountDialog
          dialogId={DELETE_ACCOUNT_DIALOG_WRAPPER_ID}
          open={true}
          handleCancel={handleCancel}
          screenRef={ScreenRef.DELETE_PROFILE}
          actionRef={ActionRef.DELETE}
          getData={getDeleteAccountState}
        />
      );
    }
    default: {
      return null;
    }
  }
};
